// @flow
import type { RenewalStatus, Subscription } from 'digicel-kaizen-library';
import { trackAnalyticsEvent } from '../../lib/analytics';

export type SubscriptionAction =
  | {|
      type: 'SWITCH_PLAN_MODE',
      payload: {
        mode: RenewalStatus,
      },
    |}
  | {|
      type: 'CANCEL_PLAN_REQUEST',
    |}
  | {|
      type: 'SAVE_AS_FIRST_SUBSCRIPTION',
      payload: { subscription: Subscription },
    |};

export type SwitchModeAction =
  | {|
      type: 'SWITCH_MODE_REQUEST',
    |}
  | {|
      type: 'SWITCH_MODE_SUCCESS',
      response: any,
    |}
  | {|
      type: 'SWITCH_MODE_FAILURE',
    |};

export type ChangePlanAction =
  | {|
      type: 'CHANGE_PLAN',
    |}
  | {|
      type: 'UPDATE_CHANGE_PLAN_DATE',
      date: Date,
    |};

export const switchMode = (mode: RenewalStatus): SubscriptionAction => ({
  type: 'SWITCH_PLAN_MODE',
  payload: {
    mode,
  },
});

export const setCurrentSubscription = (subscription: any) => ({
  type: 'SET_CURRENT_SUBSCRIPTION',
  subscription,
});

export const cancelPlanRequest = (): SubscriptionAction => ({
  type: 'CANCEL_PLAN_REQUEST',
});

export const saveAsFirstSubscription = (subscription: Subscription): SubscriptionAction => ({
  type: 'SAVE_AS_FIRST_SUBSCRIPTION',
  payload: { subscription },
});

export const changePlan = (): ChangePlanAction => {
  trackAnalyticsEvent('change_plan');
  return {
    type: 'CHANGE_PLAN',
  };
};

export const updateChangePlanDate = (date: Date): ChangePlanAction => ({
  type: 'UPDATE_CHANGE_PLAN_DATE',
  date,
});

export const switchModeRequest = (): SwitchModeAction => ({
  type: 'SWITCH_MODE_REQUEST',
});

export const switchModeSuccess = (response: any): SwitchModeAction => ({
  type: 'SWITCH_MODE_SUCCESS',
  response,
});

export const switchModeFailure = (): SwitchModeAction => ({
  type: 'SWITCH_MODE_FAILURE',
});
